import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { AnimeCard } from "@/components/AnimeCard";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export const RelatedAnime = ({ animeId }) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    setList([]);
    api.get(`/anime/${animeId}/related`).then((r) => setList(r.data)).catch(() => {});
  }, [animeId]);
  if (!list.length) return null;
  return (
    <Reveal>
      <section data-testid="related-anime-section" className="max-w-[1400px] mx-auto px-5 sm:px-8 mt-24">
        <div className="flex items-center gap-3 mb-8">
          <Sparkles size={16} className="text-[#00F0FF]" />
          <span className="kp-eyebrow">You might also like</span>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6">
          {list.map((a, i) => <AnimeCard key={a.id} anime={a} index={i} />)}
        </div>
      </section>
    </Reveal>
  );
};
